module.exports = __webpack_public_path__ + "img/manda_036.e59754e7.png";